export default "__VITE_ASSET__DKgYe_Ru__"